import type { CSSProperties } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { tokens } from '../../../design-system/tokens';
import { buildHelpDocsPath } from './docsBaseUrl';
import { resolveConsoleHelp } from './helpRoutes';

const toolbarBtn: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 40,
  height: 40,
  borderRadius: 10,
  border: `1px solid ${tokens.semantic.border}`,
  background: tokens.semantic.surface,
  color: tokens.semantic.textSecondary,
  cursor: 'pointer',
  transition: 'background 0.15s ease, color 0.15s ease',
};

/**
 * Punto único de acceso a documentación: icono en la barra superior (junto a notificaciones).
 * Abre `/app/docs/...` contextual; en super admin abre `/docs/...` en nueva pestaña.
 */
export function ConsoleHelpLink() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const help = resolveConsoleHelp(pathname);
  const to = buildHelpDocsPath(pathname, help);
  const isSuper = pathname.startsWith('/super');
  const label = isSuper
    ? `Ayuda: ${help.title} (nueva pestaña)`
    : `Ayuda: ${help.title} (abrir documentación)`;

  const open = () => {
    if (isSuper) {
      window.open(to, '_blank', 'noopener,noreferrer');
    } else {
      navigate(to);
    }
  };

  return (
    <button
      type="button"
      onClick={open}
      aria-label={label}
      title={`Ayuda — ${help.title}`}
      style={toolbarBtn}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = tokens.semantic.surfaceSubtle;
        e.currentTarget.style.color = tokens.semantic.textPrimary;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = tokens.semantic.surface;
        e.currentTarget.style.color = tokens.semantic.textSecondary;
      }}
    >
      <svg width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} aria-hidden>
        <circle cx="12" cy="12" r="10" />
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" strokeLinecap="round" strokeLinejoin="round" />
        <line x1="12" y1="17" x2="12.01" y2="17" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </button>
  );
}
